import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import translate from "@insite/client-framework/Translate";
import FieldDefinition from "@insite/client-framework/Types/FieldDefinition";
import InShellEditNotice from "@store/Components/InShellEditNotice/InShellEditNotice";
import React, { FC, PropsWithChildren } from "react";

export const enum dependentContainerFields {
    dependentFieldKey = "dependentFieldKey",
    dependentFieldValue = "dependentFieldValue",
}

export interface DependentContainerProps {
    dependentFieldKey: string;
    dependentFieldValue: string;
    meetRequirements: boolean;
}

export interface DependentContainerFieldsProps {
    [dependentContainerFields.dependentFieldKey]: string;
    [dependentContainerFields.dependentFieldValue]: string;
}

type Props = DependentContainerFieldsProps & DependentContainerProps;

const DependentContainer: FC<PropsWithChildren<Props>> = ({
    dependentFieldKey,
    dependentFieldValue,
    meetRequirements,
    children,
}) => {
    const { isEditing } = useShellContext();

    return meetRequirements || isEditing ? (
        <>
            {dependentFieldKey && dependentFieldValue && (
                <InShellEditNotice>
                    <>
                        {translate("Content preview avaialble in Edit Mode.")}
                        <br />
                        {translate("Requires {0} to be {1}", dependentFieldKey, dependentFieldValue)}
                    </>
                </InShellEditNotice>
            )}
            {children}
        </>
    ) : null;
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

export const dependentContainerFieldDefinitions: FieldDefinition[] = [
    {
        name: dependentContainerFields.dependentFieldKey,
        displayName: "Dependent Field Key",
        editorTemplate: "TextField",
        tooltip: "{prefix}_{label} e.g. Address_Postal code",
        fieldType: "Contextual",
        defaultValue: "",
        tab: advancedTab,
    },
    {
        name: dependentContainerFields.dependentFieldValue,
        displayName: "Dependent Field Value",
        editorTemplate: "TextField",
        fieldType: "Contextual",
        defaultValue: "",
        tab: advancedTab,
    },
];

export default DependentContainer;
